import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import "@arco-design/web-react/es/Notification/style";
import _Notification from "@arco-design/web-react/es/Notification";
import { ejectPromise, wait } from '@livelybone/promise-wait';
import axios from 'axios';
import { nanoid } from 'nanoid';
import { getErrorMsg } from '../utils/fns';
// import { sentry } from '@/utils/sentry';
import { AuthToken, LocalUser } from './UserStorage';
import { host as baseURL } from './api';
class HttpTasksManager {
  /**
   * 当前请求队列
   * - isBlock 表示请求与其他请求互斥，同一时间不能存在另一个正在连接的请求
   * */
  httpTasks = [];
  async addTask(id, runner, isBlock, blockTimeAfterRun) {
    if (isBlock || this.httpTasks.some(it => it.isBlock)) {
      while (this.httpTasks.length) {
        const task = this.httpTasks.shift();
        await task?.runner();
        if (task?.isBlock && task.blockTimeAfterRun) {
          await wait(task.blockTimeAfterRun);
        }
      }
    }
    this.httpTasks.push({
      id,
      runner,
      isBlock,
      blockTimeAfterRun
    });
  }
}
const tasksManager = new HttpTasksManager();

// const codeMessage = {
//   200: '服务器成功返回请求的数据。',
//   201: '新建或修改数据成功。',
//   202: '一个请求已经进入后台排队（异步任务）。',
//   204: '删除数据成功。',
//   400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
//   401: '用户没有权限（令牌、用户名、密码错误）。',
//   403: '用户得到授权，但是访问是被禁止的。',
//   404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
//   406: '请求的格式不可得。',
//   410: '请求的资源被永久删除，且不会再得到的。',
//   422: '当创建一个对象时，发生一个验证错误。',
//   500: '服务器发生错误，请检查服务器。',
//   502: '网关错误。',
//   503: '服务不可用，服务器暂时过载或维护。',
//   504: '网关超时。',
// };
const codeMessage = {
  200: 'The server successfully returned the requested data.',
  201: 'Data is created or modified successfully.',
  202: 'A request has been queued in the background (asynchronous task).',
  204: 'Succeeded in deleting data.',
  400: 'The server did not create or modify data.',
  401: 'User does not have permission (wrong token, username, password).',
  403: 'The user is authorized, but access is prohibited.',
  404: 'The request was made for a nonexistent record, and the server did not act on it.',
  406: 'The requested format is not available.',
  410: 'The requested resource is permanently deleted and will not be retrieved.',
  422: 'A validation error occurred while creating an object.',
  500: 'An error occurred on the server. Check the server.',
  502: 'Gateway error.',
  503: 'The service is unavailable, the server is temporarily overloaded or maintained.',
  504: 'The gateway timed out.'
};
export function logout() {
  AuthToken.remove();
  LocalUser.setter(null);
  const loginPath = location.host + '/login';
  if (!window.location.pathname.includes('login')) {
    window.location.replace(`${location.protocol}//${loginPath}?redirect=${window.location.pathname.includes('reset-password') ? '' : window.location.origin + window.location.pathname}`);
  }
}

/** 异常处理程序 */
const errorHandler = error => {
  const {
    config,
    response,
    request
  } = error;
  const showNotification = config?.showNotification;
  const url = config?.url || request?.options?.url || request?.url;
  const status = response?.status;
  const code = response?.data?.code;
  const statusText = response?.statusText;
  const message = !status ? error.message || 'Network connection failed...' : response?.data?.message || error.message;
  Object.assign(error, {
    url,
    status,
    code,
    statusText,
    params: JSON.stringify(config?.params),
    data: JSON.stringify(config?.data),
    message
  });
  const notice = async params => {
    console.warn('Api', error, {
      ...error
    }, params);
    if (!showNotification) return null;
    return _Notification.error(params);
  };
  if (!url) return Promise.reject(error);
  if (status) {
    if (!url.includes('login') && !location.href.includes('reset-password') && ([401].includes(status) || message.includes('Authentication failed'))) {
      // console.log('logout==========================', url);
      logout();
    }
    return Promise.reject(error);
  }
  return Promise.reject(error);
};
const http = axios.create({
  // baseURL: [process.env.BACKEND, '/api'].join('///').replace(/\/{3,}/, '/'),
  baseURL,
  // baseURL: 'http://192.168.18.61:8080/api',
  withCredentials: true,
  // 默认请求是否带上cookie
  timeout: 30000
});
http.interceptors.request.use(async options => {
  const id = nanoid();
  const taskResult = ejectPromise();
  await tasksManager.addTask(id, () => taskResult, !!options.block, options.blockTimeAfterResponse);
  // 上面这段代码用于管理 http 请求队列，目前就是针对 token 刷新时老 token 失效问题设计的解决方案

  return {
    ...options,
    id,
    afterResponse: taskResult.resolve,
    params: {
      ...options.params,
      _t: Date.now()
    },
    headers: {
      ...options.headers,
      Authorization: `Bearer ${AuthToken.get()?.replace(/"/g, '') || ''}`
    }
  };
});
http.interceptors.response.use(async res => {
  const response = res;
  const options = response.config;
  options.afterResponse?.();
  const {
    data
  } = response;
  if (data instanceof Blob) return data;
  if (!data.succ || data.code !== 0 && data.code !== 200) {
    const error = new Error(getErrorMsg(data) || 'Unknown error');
    if (!location.href.includes('reset-password') && !res.config.url?.includes('notification/list') && !res.config.url?.includes('user/info')) _Message.error(error.message || 'request error');
    Object.assign(error, {
      params: JSON.stringify(options.params),
      data: JSON.stringify(options.data),
      code: data.code,
      response: {
        ...response,
        status: response.status,
        statusText: response.statusText,
        data
      },
      request: {
        options,
        url: [options.prefix, options.url].filter(Boolean).join('')
      }
    });
    throw error;
  }
  const $message = data.message.toLowerCase();
  if (data.message == 'FORCE_CHANGE_PASSWORD' || $message.includes('change') && $message.includes('password')) {
    location.href = location.origin + '/auth/reset-password' + location.search;
    return;
  }
  return {
    ...response.data,
    response: response
  };
});
http.interceptors.response.use(undefined, error => {
  error.config?.afterResponse?.();
  return errorHandler(error).catch(err => {
    if (err.status) {
      const msg = String(getErrorMsg(err)).replace(new RegExp(`^(${err.url}\\s*)?`), err.url + ' ');
      const fetchErr = new Error(`Failed to fetch (status: ${err.status}, code: ${err.code}): ${msg}`);
      fetchErr.cause = err;
    }
    return Promise.reject(err);
  });
});
export { http };
export function httpRetry(api, options) {
  const count = options?.count || 3;
  const interval = options?.interval || 100;
  const shouldRetry = options?.shouldRetry || (res => !res);
  return async (...args) => {
    let res;
    for (let i = 0; shouldRetry(res) && i < count; i++) {
      res = await api(...args).catch(() => null);
      await wait(interval);
    }
    return res;
  };
}